'use client'
import Page from '../../../calendari/llistat/page'
import { useTorContext } from 'utils/context'

const TableCalendar = () => {
  const { torDetails } = useTorContext()
  return <Page defaultCategory={torDetails} />
}

export default TableCalendar
